// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Link from "next/link";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as DownloadHelpers$PorterinFeature from "../../helpers/DownloadHelpers.mjs";
import * as StickyVisibilityContext$PorterinFeature from "../../../../contexts/sticky-visibilty-context/StickyVisibilityContext.mjs";
import * as DownloadAppSectionModuleScss from "../styles/DownloadAppSection.module.scss";

var styles = DownloadAppSectionModuleScss;

function DownloadAppSectionCmp(Props) {
  var data = Props.data;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var containerRef = React.useRef(null);
  var match = StickyVisibilityContext$PorterinFeature.useStickyVisibilityContext(undefined);
  var setIsStickyHidden = match.setIsStickyHidden;
  var isStickyHidden = match.isStickyHidden;
  React.useEffect((function () {
          return DownloadHelpers$PorterinFeature.hideStickyBasedOnScroll("0px 0px", 1.0, containerRef, isStickyHidden, setIsStickyHidden);
        }), []);
  return React.createElement("div", {
              ref: containerRef,
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles.container
                }, React.createElement("div", {
                      className: styles.title
                    }, data.title), React.createElement("div", {
                      className: styles.icon
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: data.app_icon.path,
                          height: 87.0,
                          width: 87.0,
                          quality: 100.0,
                          alt: data.app_icon.alt_text
                        })), React.createElement("div", {
                      className: styles["sub-title"]
                    }, data.sub_text), React.createElement("button", {
                      className: styles["download-button"],
                      onClick: (function (param) {
                          DownloadHelpers$PorterinFeature.downloadGaEvent(citySelectedContext.category);
                        })
                    }, React.createElement(Link, {
                          href: data.button_href,
                          children: data.button_label
                        })), React.createElement("div", {
                      className: styles["download-icons"]
                    }, React.createElement("div", {
                          className: styles["download-android"]
                        }, React.createElement("a", {
                              href: "/android-app"
                            }, React.createElement(NextImage$PorterinFeature.make, {
                                  src: data.google_play_store_image.path,
                                  height: 25.9,
                                  width: 86.0,
                                  quality: 75.0,
                                  alt: data.google_play_store_image.alt_text
                                }))), React.createElement("div", {
                          className: styles.divider
                        }), React.createElement("div", {
                          className: styles["download-ios"]
                        }, React.createElement("a", {
                              href: "/iphone-app"
                            }, React.createElement(NextImage$PorterinFeature.make, {
                                  src: data.app_store_image.path,
                                  height: 25.9,
                                  width: 86.0,
                                  quality: 75.0,
                                  alt: data.app_store_image.alt_text
                                })))), React.createElement("div", {
                      className: styles["blue-gradient"]
                    }), React.createElement("div", {
                      className: styles["orange-gradient"]
                    })));
}

var Link$1;

var make = DownloadAppSectionCmp;

var $$default = DownloadAppSectionCmp;

export {
  styles ,
  Link$1 as Link,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
